import Vue from "vue";
const vm = Vue.prototype;
import $i18n from "../i18n";

import checkApp from "../service/check-application.js";
import fileTypes from "../service/file-types.js";
import toDate from "../service/to-date.js";
import { getRef, clearRef } from "../utils/referral";

export const state = () => ({
  application: checkApp(),
  disabilitys: [],
  countrys: [],
  regions: [],
  citys: [],
  schoolRegions: [],
  schoolCitys: [],
  educationFacultys: [],
  educationTypes: [],
  educationLanguages: [],
  schoolTypes: [],
  certificates: [],
  additionalFaculties: [],
});

export const mutations = {
  INIT_APPLICATION(state, payload) {
    state.application = payload;
  },

  SET_APPLICATION(state, payload) {
    state.application = payload || checkApp();
  },

  INIT_DISABILITYS(state, payload) {
    state.disabilitys = vm.$toArray(payload);
  },

  INIT_COUNTRYS(state, payload) {
    state.countrys = vm.$toArray(payload);
    state.regions = [];
    state.citys = [];
  },

  INIT_REGIONS(state, payload) {
    state.regions = vm.$toArray(payload);
    state.citys = [];
  },

  INIT_CITYS(state, payload) {
    state.citys = vm.$toArray(payload);
  },

  INIT_SCHOOL_REGIONS(state, payload) {
    state.schoolRegions = vm.$toArray(payload);
    state.schoolCitys = [];
  },

  INIT_SCHOOL_CITYS(state, payload) {
    state.schoolCitys = vm.$toArray(payload);
  },

  INIT_EDUCATION_FACULTYS(state, payload) {
    state.educationFacultys = vm.$toArray(payload);
    state.educationTypes = [];
  },

  INIT_EDUCATION_TYPES(state, payload) {
    state.educationTypes = vm.$toArray(payload);
    state.EducationLanguages = [];
  },

  INIT_EDUCATION_LANGUAGES(state, payload) {
    state.educationLanguages = vm.$toArray(payload);
  },

  INIT_SCHOOL_TYPES(state, payload) {
    state.schoolTypes = vm.$toArray(payload);
  },

  INIT_CERTIFICATES(state, payload) {
    state.certificates = vm.$toArray(payload);
  },

  INIT_ADDITIONAL_FACULTIES(state, { data, initial }) {
    const items = vm.$toArray(data);
    state.additionalFaculties = items;

    let count = items.length < 8 ? items.length : 8;

    if (initial && state.application.additionalFaculty.length) {
      count -= state.application.additionalFaculty.length;
      for (let index = 0; index < count; index++) {
        state.application.additionalFaculty.push({ id: null });
      }
    } else {
      state.application.additionalFaculty = [];
      for (let index = 0; index < count; index++) {
        state.application.additionalFaculty.push({ id: null });
      }
    }
  },

  SET_APPLICATION_PHOTO(state, { param, url }) {
    const obj = { ...state.application };
    obj[param] = url;
    state.application = obj;
  },
};

export const actions = {
  async SET_APP_TYPE(ctx, payload) {
    const data = await vm.$axios.$post(
      "abiturient/application/set-type",
      payload
    );
    return data != null;
  },

  async INIT_APPLICATION({ state, dispatch, commit }, application) {
    let app = application;

    if (!app) {
      const payload = await vm.$axios.$get("abiturient/application");
      app = checkApp(payload);
    }

    commit("INIT_APPLICATION", app);

    dispatch("INIT_DISABILITYS");
    dispatch("INIT_COUNTRYS");
    dispatch("INIT_SCHOOL_REGIONS");
    dispatch("INIT_SCHOOL_TYPES");
    dispatch("INIT_CERTIFICATES");
    await dispatch("INIT_EDUCATION_FACULTYS");
    await dispatch("INIT_REGIONS", { countryId: app.country.id });
    await dispatch("INIT_CITYS", { regionId: app.region.id });
    await dispatch("INIT_SCHOOL_CITYS", { regionId: app.region.id });
    await dispatch("INIT_EDUCATION_TYPES", { id: app.educationFaculty.id });
    await dispatch("INIT_EDUCATION_LANGUAGES", {
      typeId: app.educationType.id,
      facultyId: app.educationFaculty.id,
    });

    if (app.educationLanguage.id) {
      const langs = state.educationLanguages;
      const lang = langs.find((x) => x.language.id == app.educationLanguage.id);

      if (lang) {
        app.scienceComplex = lang.scienceComplex || {};

        await dispatch("INIT_ADDITIONAL_FACULTIES", {
          scienceComplexId: app.scienceComplex.id,
          facultyId: app.educationFaculty.id,
          typeId1: app.educationType.id,
          initial: true,
        });
      }
    }
  },

  SET_APPLICATION({ commit }, payload) {
    commit("SET_APPLICATION", payload);
  },

  async SAVE_APPLICATION({ commit, dispatch }, application) {
    const params = { ...application };
    const url = "abiturient/application";
    params.birthDate = toDate(params.birthDate);
    params.ref = getRef();

    const data = await vm.$axios.$post(url, params);
    const status = data != null;
    if (status) {
      clearRef();
      application.status = "SUBMITTED";
      commit("SET_APPLICATION", application);

      dispatch(
        "SET_SNACKBAR",
        {
          text: $i18n.t("Successfully sent!"),
          color: "success",
        },
        { root: true }
      );
    }

    return status;
  },

  async PART_SAVE_APPLICATION({ commit, dispatch }, application) {
    const params = { ...application };
    const url = "abiturient/application";
    params.birthDate = toDate(params.birthDate);
    params.ref = getRef();

    const data = await vm.$axios.$post(url, params);
    const status = data != null;
    if (status) {
      commit("SET_APPLICATION", application);
      dispatch(
        "SET_SNACKBAR",
        {
          text: $i18n.t("Successfully sent!"),
          color: "success",
        },
        { root: true }
      );
    }

    return status;
  },

  async INIT_DISABILITYS({ commit }) {
    const payload = await vm.$axios.$get("abiturient/disability/all"); //--

    commit("INIT_DISABILITYS", payload);
  },

  async INIT_SCHOOL_TYPES({ commit }) {
    const payload = await vm.$axios.$get("abiturient/school-type/all");
    commit("INIT_SCHOOL_TYPES", payload);
  },

  async INIT_CERTIFICATES({ commit }) {
    const url = "abiturient/foreign-language-proficiency/all"; //--
    const payload = await vm.$axios.$get(url);
    commit("INIT_CERTIFICATES", payload);
  },

  async INIT_COUNTRYS({ commit }) {
    const payload = await vm.$axios.$get("abiturient/address/country/all");
    commit("INIT_COUNTRYS", payload);
  },

  async INIT_REGIONS({ commit }, { countryId }) {
    commit("INIT_REGIONS", []);
    if (countryId) {
      const url = `abiturient/address/region/all/${countryId}`;
      const payload = await vm.$axios.$get(url);
      commit("INIT_REGIONS", payload);
    }
  },

  async INIT_CITYS({ commit }, { regionId }) {
    commit("INIT_CITYS", []);
    if (regionId) {
      const url = `abiturient/address/city/all/${regionId}`;
      const payload = await vm.$axios.$get(url);
      commit("INIT_CITYS", payload);
    }
  },

  async INIT_SCHOOL_REGIONS({ commit }) {
    commit("INIT_SCHOOL_REGIONS", []);

    const url = `abiturient/address/region/all/${1}`;
    const payload = await vm.$axios.$get(url);
    commit("INIT_SCHOOL_REGIONS", payload);
  },

  async INIT_SCHOOL_CITYS({ commit }, { regionId }) {
    commit("INIT_SCHOOL_CITYS", []);

    if (regionId) {
      const url = `abiturient/address/city/all/${regionId}`;

      const payload = await vm.$axios.$get(url);
      commit("INIT_SCHOOL_CITYS", payload);
    }
  },

  async INIT_EDUCATION_FACULTYS({ commit }) {
    commit("INIT_EDUCATION_FACULTYS", []);

    const url = `abiturient/education/faculty/all`;
    const payload = await vm.$axios.$get(url);
    commit("INIT_EDUCATION_FACULTYS", payload);
  },

  async INIT_EDUCATION_TYPES({ commit }, { id }) {
    commit("INIT_EDUCATION_TYPES", []);

    if (id) {
      const url = `abiturient/education/${id}/type/all`;
      const payload = await vm.$axios.$get(url);
      commit("INIT_EDUCATION_TYPES", payload);
    }
  },

  async INIT_EDUCATION_LANGUAGES({ commit }, { typeId, facultyId }) {
    commit("INIT_EDUCATION_LANGUAGES", []);

    if (typeId && facultyId) {
      const url = `abiturient/education/${facultyId}/${typeId}/language/all`;
      const payload = await vm.$axios.$get(url);

      commit("INIT_EDUCATION_LANGUAGES", payload);
    }
  },

  async INIT_ADDITIONAL_FACULTIES(
    { commit },
    { scienceComplexId, facultyId, typeId1, initial }
  ) {
    if (!initial) {
      commit("INIT_ADDITIONAL_FACULTIES", []);
    }

    if (scienceComplexId && facultyId && typeId1) {
      const url = `abiturient/education/${facultyId}/${scienceComplexId}/${typeId1}/additional-faculties/all`;
      const payload = await vm.$axios.$get(url);

      commit("INIT_ADDITIONAL_FACULTIES", { data: payload, initial });
    }
  },

  async UPLOAD_FILE({ commit }, { file, param }) {
    const fileType = fileTypes[param];
    if (fileType) {
      const form = new FormData();
      form.append("file", file);

      const url = `abiturient/application/file/${fileType}`;
      const data = await vm.$axios.$post(url, form);

      if (data) {
        commit("SET_APPLICATION_PHOTO", { url: data, param });
      }
    }
  },

  async GET_FILE_API(ctx, { url }) {
    if (url) {
      return await vm.$axios.$getImage(url);
    } else return null;
  },

  async DELETE_FILE_API({ commit }, { param }) {
    const fileType = fileTypes[param];

    if (fileType) {
      const url = `abiturient/application/file/${fileType}`;
      const status = await vm.$axios.$delete(url);

      if (status != null) {
        commit("SET_APPLICATION_PHOTO", { url: null, param });
      }
    }
  },
};

export const getters = {
  GET_APPLICATION: (state) => state.application,
  GET_DISABILITYS: (state) => state.disabilitys,
  GET_COUNTRYS: (state) => state.countrys,
  GET_REGIONS: (state) => state.regions,
  GET_CITYS: (state) => state.citys,
  GET_SCHOOL_REGIONS: (state) => state.schoolRegions,
  GET_SCHOOL_CITYS: (state) => state.schoolCitys,
  GET_EDUCATION_FACULTYS: (state) => state.educationFacultys,
  GET_EDUCATION_TYPES: (state) => state.educationTypes,
  GET_EDUCATION_LANGUAGES: (state) => state.educationLanguages,
  GET_SCHOOL_TYPES: (state) => state.schoolTypes,
  GET_CERTIFICATES: (state) => state.certificates,
  GET_ADDITIONAL_FACULTIES: (state) => state.additionalFaculties,
};
